// Module
var code = "<div class=\"vui-select__dropdown ignore-fullscreen-scroll\" ng-transclude></div>\n";
// Exports
module.exports = code;